import { render } from "./SettingsManage.vue?vue&type=template&id=0d99fc1f"
import script from "./SettingsManage.vue?vue&type=script&lang=js"
export * from "./SettingsManage.vue?vue&type=script&lang=js"

import "./SettingsManage.vue?vue&type=style&index=0&id=0d99fc1f&lang=less"

import exportComponent from "D:\\VueProject\\Cigl-Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__